import log from "loglevel";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import Select from "../common/Select";

class UserSelect extends React.Component {
    static defaultProps = {
        placeholder: "Users",
    };
    constructor(props) {
        super(props);
        this.state = {
            value: props.defaultValue ? props.defaultValue : props.multiple ? [] : null,
        };
        this.onChange = this.onChange.bind(this);
    }
    onChange(value) {
        log.debug("user", value);
        this.setState({ value }, () => {
            this.props.onChange(this.state.value);
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) {
            this.setState({ value: this.props.defaultValue });
        }
    }

    render() {
        const { value } = this.state;
        const { users, multiple, placeholder } = this.props;
        const data = users.filter((type) => type.name !== "").map((type) => ({ value: type.id, label: type.name }));
        return (
            <Select
                placeholder={placeholder}
                value={value}
                defaultMenuPortalTarget
                multiple={multiple}
                onChange={this.onChange}
                options={data}
            />
        );
    }
}

UserSelect.propTypes = {
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    onChange: PropTypes.func.isRequired,
    multiple: PropTypes.bool,
    placeholder: PropTypes.string,
    users: PropTypes.array.isRequired,
};

export default connect(
    ({ globalApp }) => ({
        users: globalApp.users,
    }),
    null
)(UserSelect);
